import { defineStore } from 'pinia'
import { User } from '@/pages/users/types'
import { getMe, internalSignIn, signOut } from '@/data/pages/users'
import { LOCAL_STORAGE_KEYS } from '@/constants/localStorage'

export const useUserStore = defineStore('user', {
  state: () => {
    return {
      info: {} as User,
      exists: Boolean(localStorage.getItem(LOCAL_STORAGE_KEYS.currentUser)),
    }
  },

  actions: {
    clearAuthData() {
      ;[LOCAL_STORAGE_KEYS.accessToken, LOCAL_STORAGE_KEYS.currentUser].forEach((userField) =>
        localStorage.removeItem(userField),
      )
    },
    saveAccessCredentials(tokenType: string, accessToken: string): string {
      const fullAccessToken: string = `${tokenType} ${accessToken}`
      localStorage.setItem(LOCAL_STORAGE_KEYS.accessToken, fullAccessToken)
      return fullAccessToken
    },

    getAccessToken() {
      return localStorage.getItem(LOCAL_STORAGE_KEYS.accessToken)
    },

    async internalSignIn(data: URLSearchParams): Promise<boolean | undefined> {
      const responseData = await internalSignIn(data)
      if (responseData) {
        this.saveAccessCredentials(responseData.token_type, responseData.access_token)
        return true
      }
    },

    async signOut() {
      const accessToken = this.getAccessToken()
      if (accessToken) {
        await signOut(accessToken)
      }
      this.clearAuthData()
      this.exists = false
    },

    async getMe(): Promise<User> {
      const currentUser: User = await getMe()
      this.info = currentUser

      if (currentUser) {
        localStorage.setItem(LOCAL_STORAGE_KEYS.currentUser, JSON.stringify(currentUser))
        this.exists = true
      } else {
        this.clearAuthData()
        this.exists = false
      }
      return currentUser
    },

    async isAuthenticated(): Promise<boolean> {
      return Boolean(await this.getMe())
    },
  },
})
